import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { getTestIds } from 'seagull/utils/TestIds';
import { useStoreActions } from '~/store/store-context';
import { PracticeManagement } from '~/types/api.model';
import PMSetupPage from './PMSetupPage/PMSetupPage';
export const GetKeeperSetupTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds: {
            KeeperSetupTID: {
                Root: 'keeper-setup'
            }
        }
    });
export const KeeperSetupPage = (param)=>{
    let { integration } = param;
    const { KeeperSetupTID } = useMemo(()=>GetKeeperSetupTID(), []);
    const { api, fetchKeeperItems } = useStoreActions();
    return /*#__PURE__*/ _jsx(PMSetupPage, {
        testId: KeeperSetupTID.Root(),
        pmName: PracticeManagement.Keeper,
        integration: integration,
        getItems: fetchKeeperItems,
        doDisconnect: api.keeper.disconnect,
        linkServiceTemplate: api.keeper.linkServiceTemplate,
        getServiceTemplateIntegratedIds: (template)=>template.integrations.keeperIntegratedIds()
    });
};
